(() => {
  'use strict';
  if (window.HSXOffers) { window.HSXOffers.refresh(); return; }
  const configNode = document.getElementById('HsxOfferConfig');
  if (!configNode || !window.HSXOfferCore || !window.HSXOfferTransport) return;
  const config = JSON.parse(configNode.textContent);
  const entities={'&#39;':"'",'&quot;':'"','&amp;':'&','&lt;':'<','&gt;':'>'};
  const strings = JSON.parse(document.getElementById('HsxOfferStrings').textContent,(_key,value)=>typeof value==='string'?value.replace(/&#39;|&quot;|&amp;|&lt;|&gt;/g,entity=>entities[entity]):value);
  const core = window.HSXOfferCore;
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
  const text = (key,values={}) => Object.entries(values).reduce((s,[k,v])=>s.replaceAll('['+k+']',String(v)),strings[key]||key);
  const campaignOpen = () => !config.bfEndsAt || Date.now() < Date.parse(config.bfEndsAt);
  let mode = config.mode === 'black_friday' && campaignOpen() ? 'black_friday' : 'regular';
  const query = new URLSearchParams(location.search);
  if (config.draft && ['regular','black_friday'].includes(query.get('hsx_offer'))) mode=query.get('hsx_offer');
  const instances=new Map();
  let activePurchases=0;
  function refreshPurchaseState(){
    document.querySelectorAll('[data-offer-preview]').forEach(button=>{button.disabled=activePurchases>0;});
    for(const refresh of instances.values())refresh();
  }
  function shopLink() {
    if (document.querySelector('[data-hsx-offer]')) return '#nmn-offer';
    const u=new URL(config.productUrl,location.origin);
    if(config.draft){u.searchParams.set('hsx_offer',mode);const id=query.get('preview_theme_id');if(id)u.searchParams.set('preview_theme_id',id);}
    return u.pathname+u.search+'#nmn-offer';
  }
  function updateGlobal() {
    document.documentElement.dataset.hsxCampaignMode=mode;
    document.querySelectorAll('[data-offer-preview]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.offerPreview===mode));b.disabled=activePurchases>0;});
    document.querySelectorAll('[data-offer-campaign]').forEach(b=>{b.hidden=mode!=='black_friday';});
    document.querySelectorAll('[data-offer-shop]').forEach(a=>{a.href=shopLink();});
    document.querySelectorAll('[data-hsx-home-offer-price]').forEach(p=>{p.textContent=money(core.quote(1,'once',mode).price)+' USD';});
    document.querySelectorAll('[data-hsx-home-offer-label]').forEach(p=>{p.textContent=text('once');});
    if(mode==='black_friday')document.querySelectorAll('[data-hsx-welcome] dialog[open]').forEach(d=>d.close());
    for(const refresh of instances.values()) refresh();
    document.dispatchEvent(new CustomEvent('hsx:offerchange',{detail:{mode}}));
  }
  function switchMode(next) {
    if(activePurchases||!config.draft||!['regular','black_friday'].includes(next))return;
    mode=next;const u=new URL(location.href);u.searchParams.set('hsx_offer',mode);u.searchParams.delete('hsx_bf_popup');history.replaceState({},'',u);updateGlobal();
  }
  function bind(root) {
    if(instances.has(root))return;
    const native=JSON.parse(root.querySelector('[data-offer-native]').textContent);
    const form=root.querySelector('[data-offer-form]');
    const add=root.querySelector('[data-offer-add]');
    const status=root.querySelector('[data-offer-status]');
    const consent=root.querySelector('[data-offer-consent]');
    const record=root.querySelector('[data-offer-consent-record]');
    let consentSelection='',consentRecord='',failure='';
    let type='once',pack=1,busy=false,uncertain=false,disposed=false,requestController=null;
    const recovery=root.querySelector('[data-offer-recovery]');
    const productRoot=root.closest('[data-product-root]');
    const bar=productRoot?.querySelector('[data-hsxp-buy]');
    const footer=document.querySelector('.hsx-v2-footer,.hsxf-footer');
    let observer=null,footerObserver=null,barFrame=0;
    const findVariant = n => native.variants.find(v=>Number(v.title.match(/^\s*(\d+)/)?.[1])===Number(n));
    if(bar){
      bar.classList.add('hsx-ui');document.body.append(bar);
      bar.querySelector('a').href='#nmn-offer';root.tabIndex=-1;
      bar.querySelector('a').addEventListener('click',()=>root.focus({preventScroll:true}));
    }
    const previewInset=()=>{const frame=document.getElementById('PBarNextFrame');const h=frame&&frame.getBoundingClientRect().width&&getComputedStyle(frame).display!=='none'?Math.ceil(frame.getBoundingClientRect().height):0;document.body.style.setProperty('--hsxp-preview-inset',Math.min(96,Math.max(0,h))+'px');};
    function updateBar() {
      if(!bar)return;
      const offerBounds=root.getBoundingClientRect(),footerBounds=footer?.getBoundingClientRect();
      const footerVisible=footerBounds&&footerBounds.top<innerHeight&&footerBounds.bottom>0;
      bar.hidden=offerBounds.bottom>0||Boolean(footerVisible);
    }
    const scheduleBar=()=>{if(bar&&!barFrame)barFrame=requestAnimationFrame(()=>{barFrame=0;updateBar();});};
    const resize=()=>{previewInset();scheduleBar();};
    function refresh() {
      if(disposed)return;
      const bf=mode==='black_friday',locked=busy||activePurchases>0;
      if(busy)root.setAttribute('aria-busy','true');else root.removeAttribute('aria-busy');
      const selection=mode+'/'+type+'/'+pack;
      if(selection!==consentSelection){consentSelection=selection;consent.checked=false;consentRecord='';failure='';consent.removeAttribute('aria-invalid');}
      root.querySelector('[data-offer-title]').textContent=text(bf?'bf_heading':'regular_heading');
      root.querySelector('[data-offer-basis]').textContent=text(bf?'basis':'regular_basis');
      root.querySelector('[data-offer-qualification]').hidden=!bf;
      root.querySelector('[data-offer-end]').hidden=!bf;
      root.toggleAttribute('data-hsx-offer-subscription',type==='subscription');
      root.querySelectorAll('[data-offer-mode]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.offerMode===type));b.disabled=locked;});
      root.querySelectorAll('[data-offer-card]').forEach(card=>{
        const n=Number(card.dataset.offerCard),q=core.quote(n,type,mode);
        const label=card.querySelector('[data-offer-card-label]');label.hidden=type!=='subscription';label.textContent=text(bf?'first_payment_label':'shipment_label');
        card.querySelector('[data-offer-card-price]').textContent=money(q.price);
        card.querySelector('[data-offer-card-unit]').textContent=text('per_pouch',{price:money(Math.round(q.price/n))});
        card.querySelector('[data-offer-card-supply]').textContent=text('supply_js',{days:n*31});
        const basis=n===1?'$64.95':n+' × $64.95';
        card.querySelector('[data-offer-card-saving]').textContent=q.saving?text(bf&&type==='subscription'?'save_first':'save',{amount:money(q.saving),percent:q.percent,basis}):'';
        card.querySelector('[data-offer-card-basis]').textContent=text('future_basis');
        card.querySelector('[data-offer-card-basis]').hidden=!bf;
        const renew=card.querySelector('[data-offer-card-renewal]'),cadence=card.querySelector('[data-offer-card-cadence]');
        renew.hidden=cadence.hidden=type!=='subscription';
        renew.textContent=bf?text('renewal',{price:money(q.renewal||0),interval:n===1?'every month':'every '+n+' months'}):'';
        renew.hidden=type!=='subscription'||!bf;
        cadence.textContent=text('ships',{interval:n===1?'every month':'every '+n+' months'});
        card.querySelector('input').checked=n===pack;card.querySelector('input').disabled=locked;
      });
      const q=core.quote(pack,type,mode),variant=findVariant(pack),eligible=core.eligibility(q,variant,config,native);
      form.querySelector('[data-offer-variant]').value=variant?.id||'';
      const plan=form.querySelector('[data-offer-plan]');plan.disabled=!eligible?.planId;plan.value=eligible?.planId||'';
      const values={price:money(q.price),renewal:money(q.renewal||0),interval:pack===1?'every month':'every '+pack+' months',pouches:pack===1?'1 pouch':pack+' pouches'};
      consent.disabled=locked||type!=='subscription';
      consent.required=type==='subscription';
      consent.setAttribute('aria-required',String(type==='subscription'));
      if(consent.checked||type!=='subscription')consent.removeAttribute('aria-invalid');
      root.querySelector('[data-offer-disclosure]').hidden=type!=='subscription';
      root.querySelector('[data-offer-consent-wrap]').hidden=type!=='subscription';
      root.querySelector('[data-offer-disclosure-copy]').textContent=text(bf?'disclosure_bf':'disclosure_regular',values)+' '+text(config.freeShipping?'disclosure_shipping':'disclosure_shipping_pending')+' '+text('disclosure_controls')+(bf?' '+text('disclosure_reminder'):'');
      root.querySelector('[data-offer-consent-copy]').textContent=text(bf?'consent_bf':'consent_regular',values);
      record.disabled=type!=='subscription'||!consent.checked;record.value=consentRecord;
      add.disabled=locked||uncertain||!eligible;add.textContent=busy?text('adding'):text('add');
      status.textContent=(!eligible?text('pending'):type==='subscription'&&!consent.checked?text('consent_required'):text('taxes'))+(type==='subscription'&&consent.checked&&consentRecord?' '+text('consent_confirmed'):'');
      if(failure)status.textContent=failure;
      if(uncertain)status.textContent=text('add_uncertain');
      if(recovery)recovery.hidden=!uncertain;
      root.querySelector('[data-offer-payment]').textContent=type==='subscription'?(bf?text('first_payment',values):text('subscription_payment',values)):text('total_payment',{price:money(q.price)})+' '+text('once_note');
      root.querySelector('[data-offer-benefits]').hidden=!bf;
      root.querySelector('[data-offer-shipping]').textContent=text(config.freeShipping?'shipping_free':'shipping_planned');
      root.querySelector('[data-offer-app]').textContent=text(config.appReady?'app_included':'app_planned');
      if(bar){
        const price=bar.querySelector('[data-hsxp-price]'),option=bar.querySelector('[data-hsxp-option]');
        if(price)price.textContent=money(q.price);
        if(option)option.textContent=text('pack_count_js',{count:pack})+' · '+text(type);
        updateBar();
      }
      previewInset();
    }
    root.addEventListener('click',e=>{const b=e.target.closest('[data-offer-mode]');if(b&&!activePurchases){type=b.dataset.offerMode;refresh();}});
    root.addEventListener('change',e=>{
      if(activePurchases)return;
      if(e.target.matches('[data-offer-card] input[type=radio]'))pack=Number(e.target.value);
      if(e.target===consent){
        const q=core.quote(pack,type,mode);
        consentRecord=consent.checked?'yes · terms v'+config.termsVersion+' · '+new Date().toISOString()+' · first USD '+(q.price/100).toFixed(2)+' / renewal USD '+(q.renewal/100).toFixed(2)+' / every '+pack+' month(s) · '+pack+' pouch(es) · '+mode:'';
      }
      refresh();
    });
    consent.addEventListener('invalid',()=>{consent.setAttribute('aria-invalid','true');status.textContent=text('consent_required');});
    form.addEventListener('submit',async e=>{
      e.preventDefault();const q=core.quote(pack,type,mode),v=findVariant(pack),allowed=core.eligibility(q,v,config,native);if(!allowed||activePurchases||busy||uncertain||(type==='subscription'&&(!consent.checked||!consentRecord)))return;
      const submittedMode=mode,submittedConsent=consentRecord;
      requestController=new AbortController();
      busy=true;failure='';activePurchases++;refreshPurchaseState();
      let added=false;
      try {
        const base=window.Shopify?.routes?.root||'/';
        const outcome=await window.HSXOfferTransport.submit({
          route:base,productUrl:native.url,variantId:allowed.variantId,planId:allowed.planId,
          consent:submittedConsent,signal:requestController.signal,
          validate:fresh=>{
            if(disposed||mode!==submittedMode||(!config.draft&&submittedMode==='black_friday'&&!campaignOpen()))return false;
            const candidate=core.variantFromProduct(fresh,allowed.variantId);
            const checked=core.eligibility(q,candidate,config,{...native,id:fresh.id});
            return Boolean(checked&&String(checked.planId||'')===String(allowed.planId||''));
          }
        });
        added=true;
        if(!disposed)location.assign(outcome.cartPath);
      } catch(error) {
        if(!disposed){
          uncertain=added||Boolean(error.uncertain);busy=false;
          failure=uncertain?text('add_uncertain'):text(error.code&&strings[error.code]?error.code:'error');
        }
      } finally {
        activePurchases=Math.max(0,activePurchases-1);requestController=null;
        if(!added)busy=false;
        refreshPurchaseState();
      }
    });
    if(bar&&'IntersectionObserver'in window){observer=new IntersectionObserver(updateBar);observer.observe(root);}
    if(bar&&footer&&'IntersectionObserver'in window){footerObserver=new IntersectionObserver(updateBar);footerObserver.observe(footer);}
    if(bar)addEventListener('scroll',scheduleBar,{passive:true});
    addEventListener('resize',resize,{passive:true});
    instances.set(root,refresh);refresh();
    root._hsxfDispose=()=>{disposed=true;requestController?.abort();observer?.disconnect();footerObserver?.disconnect();if(barFrame)cancelAnimationFrame(barFrame);removeEventListener('scroll',scheduleBar);removeEventListener('resize',resize);bar?.remove();instances.delete(root);};
  }
  document.addEventListener('click',e=>{const b=e.target.closest('[data-offer-preview]');if(b)switchMode(b.dataset.offerPreview);});
  function init(scope=document){scope.querySelectorAll('[data-hsx-offer]').forEach(bind);updateGlobal();}
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-hsx-offer]').forEach(r=>r._hsxfDispose?.()));
  window.HSXOffers=Object.freeze({refresh:()=>init(),get mode(){return mode;},config,text});
  if(!config.draft&&config.bfEndsAt){setInterval(()=>{if(!activePurchases&&mode==='black_friday'&&!campaignOpen()){mode='regular';updateGlobal();}},30000);}
  init();
})();
